import * as yup from 'yup';

import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { getNextDay } from '@/utils/dates/dates';
import type { OPTIONAL_ROLE } from '@/features/Clients';
import {
  generateVpSchemaForRole,
  vpSchema,
} from '@/features/Sparten/unf/schema/vpSchema/vpSchema';
import { getMessage } from '@/features/validation/locales';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';

export const inputSchema = yup.object({
  versicherungsbeginn: yup.date().default(getNextDay()).required(),
  laufzeit: yup.string().required().default(''),
  zahlweise: yup.string().required().default(''),
  demvRabattiert: yup.bool().default(true),
  gesundheitsfragenVerzicht: yup.bool().default(false),
  tarifgruppe: yup.string().required().default(''),
  versichertePerson: vpSchema(),
  versichertePerson2: generateVpSchemaForRole(
    'versichertePerson2' as OPTIONAL_ROLE,
  ),
  versichertePerson3: generateVpSchemaForRole(
    'versichertePerson3' as OPTIONAL_ROLE,
  ),
  versichertePerson4: generateVpSchemaForRole(
    'versichertePerson4' as OPTIONAL_ROLE,
  ),
  versichertePerson5: generateVpSchemaForRole(
    'versichertePerson5' as OPTIONAL_ROLE,
  ),
  versichertePerson6: generateVpSchemaForRole(
    'versichertePerson6' as OPTIONAL_ROLE,
  ),
  vorschaden: yup.string().default('').required(),
  vorversicherung: yup
    .string()
    .required()
    .default('')
    .test(
      'isValidVorversichung',
      getMessage('mixed.required'),
      (value) =>
        !getSimpleChoiceMeta(
          SIMPLE_CHOICE.VORVERSICHERUNG,
          SIMPLE_CHOICE_META.VORVERSICHERUNG_INVALID,
        ).includes(value),
    ),
});

export type InputStore = yup.Asserts<typeof inputSchema>;

const defaultState = inputSchema.getDefault() as InputStore;

export const useUnfInputStore = genericStoreFactory(
  defaultState,
  'UnfInputStore',
);
